//src/validation-schemas/cancel-order-schemas/index.ts
import { z } from "zod";

export const cancelOrderFormSchema = z.object({
  orderId: z
    .number({
      required_error: "Order-Id is required.",
      invalid_type_error: "Order-Id must be a number.",
    })
     .refine((val) => val > 0, {
      message: "Order-Id must be a positive number",
    }),     

  reason: z
    .string()
    .trim()
    .nonempty("Reason is required.")
    .min(10, "Reason must be at least 10 characters")
    .max(700, "Reason must be less than 700 characters")
    .trim()
    .refine((val) => val.length > 0, {
      message: "Reason cannot be only spaces",
    }),
});

export type CancelOrderFormSchema = z.infer<typeof cancelOrderFormSchema>;
